import { defineStore } from 'pinia';

export enum AlertTypes {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error'
}

export interface Alert {
  id: string;
  message: string;
  alertType?: AlertTypes;
  alertTimestamp: number;
  dismissable?: boolean;
  autoDismissDelay?: number;
  title?: string;
  icon?: string;
}

type Store = {
  alerts: Array<Alert>;
};

export const useAlertStore = defineStore('alerts', {
  state: (): Store => ({
    alerts: []
  }),
  getters: {
    getAlerts(state): Alert[] {
      return state.alerts;
    }
  },
  actions: {
    /**
     * Add an alert to the store
     * @param alert the alert to add
     */
    addAlert(alert: Alert) {
      if (!this.alerts.filter((a) => a.id === alert.id).length) {
        this.alerts.push(alert);

        if (alert.autoDismissDelay && alert.autoDismissDelay > 0) {
          setTimeout(() => {
            this.removeAlert(alert.id);
          }, alert.autoDismissDelay);
        }
      }
    },
    /**
     * Add a success action alert which will be dismissable and auto dismiss after 5 seconds
     * @param id the unique id of the alert
     * @param message the message to display
     * @param title the title of the alert (optional)
     */
    addSuccessActionAlert(id: string, message: string, title?: string) {
      const alert = {
        id: id,
        message: message,
        title: title,
        dismissable: true,
        alertType: AlertTypes.Success,
        alertTimestamp: Date.now(),
        autoDismissDelay: 5000
      }
      this.addAlert(alert);
    },
    removeAlert(id: string) {
      this.alerts = this.alerts.filter((a) => a.id !== id);
    }
  }
});
